"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getDefaultHeaders_1 = __importDefault(require("../../getDefaultHeaders"));
var http_client_1 = __importDefault(require("@fuze/apis-core/dist/http-client"));
/**
 * Retrieve all the possible roles (for all tenants)
 * @param baseUrl The base url of the API
 * @param wardenToken The authentication token for the user making the request
 * @param limit This parameter specifies the maximum amount of results allowed per call
 * @param cursor This parameter is used to iterate through the listing. Initially it can be null, but on subsequent calls it must be read from the response
 */
function getAllRoles(baseUrl, wardenToken, cursor, limit) {
    if (cursor === void 0) { cursor = ""; }
    if (limit === void 0) { limit = 100; }
    return http_client_1.default({
        method: "GET",
        url: baseUrl + "/api/v3/roles?limit=" + limit + "&cursor=" + cursor,
        headers: __assign(__assign({}, getDefaultHeaders_1.default("")), { Authorization: "Bearer " + wardenToken })
    }).then(function (response) { return response.data; });
}
exports.default = getAllRoles;
